import {
    HttpResponse,
    LocationModel,
    QueryModel,
    RequestParams,
    LocationModelIEnumerableApiResultSuccess,
    LocationModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class LocationsDataService implements CrudService<LocationModel, LocationModel> {
    getAll(query: CrudDataQuery<LocationModel>): Promise<CrudEnumerableResponse<LocationModel>> {
        return ApiService.api.getLocationBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<LocationModel>): Promise<CrudEnumerableResponse<LocationModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<LocationModel>> {
        return ApiService.api.getLocationById(id, params);
    }

    create(item: LocationModel, params?: RequestParams): Promise<CrudResponse<LocationModel>> {
        return ApiService.api.insertLocation(item, params);
    }

    update(item: LocationModel, params?: RequestParams): Promise<LocationModel> {
        return ApiService.api.updateLocation(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<LocationModel> {
        return ApiService.api.patchLocation(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<LocationModel>): Promise<CrudEnumerableResponse<LocationModel>> {
        return ApiService.api.deleteLocations(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationLocation(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<LocationModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: LocationModel, params?: RequestParams): Promise<CrudResponse<LocationModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getLocationGroupped(query, params);
    }

}
